import styled from 'styled-components';
import { themeGet } from '@styled-system/theme-get';

export const Wrapper = styled.div`
  border: 1px solid ${themeGet('border.1', '#e8eaec')};
  &.reservation-chat {
    border: 0;
    height: calc(100vh - 167px);
  }
  &.marina-messaging {
    height: calc(100vh - 105px);
  }
  @media only screen and (max-width: 991px) {
    &.reservation-chat {
      height: calc(100vh - 187px);
    }
    &.marina-messaging {
      height: calc(100vh - 125px);
    }
  }
  @media only screen and (max-width: 767px) {
    border: 0;
    width: 100%;
    z-index: 1;
    &.reservation-chat,
    &.marina-messaging {
      height: calc(100vh - 118px);
    }
  }
`;

export const MessagesScreen = styled.div`
  padding: 17px 0 17px 8px;
  position: relative;
  background-color: ${themeGet('color.1', '#ffffff')};
  &.reservation-chat {
    height: calc(100% - 92px);
  }
  &.marina-messaging {
    height: calc(100% - 132px);
  }
  @media only screen and (max-width: 991px) {
    &.marina-messaging {
      height: calc(100vh - 219px);
    }
  }
  @media only screen and (max-width: 767px) {
    padding: 17px 0 17px 21px;
    &.reservation-chat,
    &.marina-messaging {
      height: calc(100% - 78px);
    }
  }
`;

export const MessagesContainer = styled.div`
  overflow: hidden;
  position: absolute;
  width: calc(100% - 8px);
  max-height: calc(100% - 34px);
  padding-right: 16px;
  @media only screen and (max-width: 767px) {
    width: calc(100% - 22px);
  }
`;

export const MessageForm = styled.div`
  display: flex;
  justify-content: space-between;
  padding: 22px 18px 22px 28px;
  background-color: ${themeGet('color.1', '#ffffff')};
  border-top: 1px solid ${themeGet('border.1', '#e8eaec')};
  &.marina-messaging {
    padding: 22px 18px 62px 28px;
  }
  @media only screen and (max-width: 991px) {
    &.marina-messaging {
      padding: 22px 18px 22px 28px;
    }
  }
  @media only screen and (max-width: 767px) {
    &.reservation-chat,
    &.marina-messaging {
      padding: 15px 20px 15px;
    }
  }
  .send-button {
    color: ${themeGet('color.1', '#ffffff')};
    border-color: ${themeGet('primary.0', '#194AB9')};
    background-color: ${themeGet('primary.0', '#194AB9')};
    border-radius: 4px;
    height: 47px;
    font-size: 15px;
    font-weight: 700;
    padding-left: 28px;
    padding-right: 28px;
    line-height: 1;
    &:hover {
      opacity: 0.8;
    }
    @media only screen and (max-width: 480px) {
      padding-left: 15px;
      padding-right: 15px;
    }
  }
  .attach-button {
    color: ${themeGet('color.1', '#ffffff')};
    border-color: ${themeGet('primary.0', '#194AB9')};
    background-color: '#ffffff';
    border-radius: 4px;
    height: 47px;
    font-size: 15px;
    font-weight: 700;
    padding-left: 28px;
    padding-right: 28px;
    line-height: 1;
    margin-right: 5px;
    &:hover {
      opacity: 0.8;
    }
    @media only screen and (max-width: 480px) {
      padding-left: 15px;
      padding-right: 15px;
    }
  }
  .message-input {
    padding: 11px 12px;
    border-radius: 0;
    background-color: #f5f6f7;
    font-size: 16px;
    resize: none;
    margin-right: 15px;
    border-top: 0;
    border-left: 0;
    border-right: 0;
    border-bottom: 1px solid #c6cbce;
    &:focus {
      box-shadow: none;
      border-bottom: 1px solid #c6cbce;
    }
  }
`;

export const MessagesDivider = styled.div`
  text-align: center;
  color: ${themeGet('text.1', '#909090')};
  margin-bottom: 20px;
`;

export const DateString = styled.div`
  color: ${themeGet('text.1', '#909090')};
  margin-bottom: 20px;
`;

export const AvatarWrapper = styled.div`
  flex-basis: 40px;
  @media only screen and (max-width: 480px) {
    display: none;
  }
`;

export const MessageWrapper = styled.div`
  display: flex;
  margin-bottom: 20px;
  @media only screen and (max-width: 480px) {
    margin-bottom: 25px;
    padding-right: 15px;
  }
`;

export const MessageContent = styled.div`
  margin-left: 10px;
  @media only screen and (max-width: 480px) {
    margin-left: 0;
  }
`;

export const MessageHeader = styled.div`
  display: flex;
  align-items: center;
  margin-bottom: 4px;
  @media only screen and (max-width: 480px) {
    align-items: baseline;
  }
`;

export const MessageTitle = styled.h4`
  font-size: 16px;
  font-weight: bold;
  color: #4a4a4a;
  margin-bottom: 0;
  margin-right: 10px;
`;

export const MessageTime = styled.div`
  color: ${themeGet('text.1', '#909090')};
`;

export const MessageText = styled.div`
  font-size: 16px;
  color: #4a4a4a;
  a.link {
    color: ${themeGet('primary.0', '#194AB9')};
    &:hover {
      opacity: 0.8;
    }
  }
  span.link {
    color: ${themeGet('primary.0', '#194AB9')};
    cursor: pointer;
    font-size: 12px;
    &:hover {
      opacity: 0.8;
    }
  }
`;

export const StatusWrapper = styled.div`
  flex-basis: 40px;
  min-width: 40px;
  text-align: right;
  @media only screen and (max-width: 480px) {
    flex-basis: 14px;
    min-width: 14px;
    margin-right: 12px;
  }
  .status_icon {
    color: ${({ status }) => {
      const statusColors = {
        INFO: {
          code: 'primary.0',
          color: '#194AB9'
        },
        WARNING: {
          code: 'warning.0',
          color: '#F29100'
        },
        CANCELED: {
          code: 'error.0',
          color: '#F9503D'
        },
        APPROVED: {
          code: 'success.0',
          color: '#00BB5D'
        }
      };
      const { code, color } = statusColors[status];
      return themeGet(code, color);
    }};
  }
`;
